export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS'
export const SET_CATEGORIES_LOADING = 'SET_CATEGORIES_LOADING'